import React from "react";

const Lyrics = () => {
  return (
    <p>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      Ey, ey<br></br>
      <br></br>
      Yo no corro por un culo, solo por un cheque (cheque)<br></br>
      Me lo mueve y se menea, eso parece tembleque (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (ey)<br></br>
      Yo no corro por un culo, solo por un cheque (cheque)<br></br>
      Me lo mueve y se menea, eso parece tembleque (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (ey)<br></br>
      <br></br>
      Ese culo 'tá cabrón<br></br>
      Pero no tan cabrón pa' conseguir un Lambo<br></br>
      Yo no estoy para amore'<br></br>
      Pero si quiere' el culo yo te lambo<br></br>
      Como Héctor, con el miedo en la gaveta<br></br>
      Voy pa' encima como Rambo<br></br>
      Dándole de'o a tu gata<br></br>
      Cuando guío mientra' le meto los cambio'<br></br>
      No me hable' de amore'<br></br>
      Mejor cómprame condone'<br></br>
      No me llamen pa' rumore', no me llamen pa' favore'<br></br>I don't chase a
      bitch, I chase a check<br></br>
      Capitán Philipp con mi Patek<br></br>
      <br></br>I don't chase a bitch, I chase a check<br></br>
      Capitán Philipp con mi Patek (ey)<br></br>
      Yo no corro por un culo, solo por un cheque (cheque)<br></br>
      Me lo mueve y se menea, eso parece tembleque (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (ey)<br></br>
      Yo no corro por un culo, solo por un cheque (cheque)<br></br>
      Me lo mueve y se menea, eso parece tembleque (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (Jon Z, man, wuh) (ey)<br></br>
      <br></br>
      Yo no corro por un culo (no, no)<br></br>
      Soy un cabron hijeputa (yih)<br></br>
      Corro por los cheque', los cheque'<br></br>
      Pa' comprar los kilo' y ponerlo' en ruta (krr, paw)<br></br>
      Ahora me dicen "Jon mula" (mula)<br></br>
      Paca' gorda', flow Abdullah (yeah, yeah)<br></br>
      Fumando llegando a la altura (krr)<br></br>
      Coca-Cola y la Perco me dura (yah, wuh)<br></br>
      Culo' no persigo, a mí me persiguen<br></br>
      Son mucho' que niego y comoquiera siguen (yih)<br></br>
      To'a se reunen pa' hacer un despingue (ya)<br></br>
      Yo nunca pago para que a mí me chinguen (wuh)<br></br>
      Raperito' cantan lo que uno vive (krr)<br></br>
      Porque la vida real de ello' no sirve (paw)<br></br>
      Siguen imitando y no llegan al nivel (paw, paw)<br></br>
      Mis disco' platino', los tuyo' son silver (paw, paw)<br></br>
      <br></br>
      Silver como tu' cadena' bañá' en oro (anjá)<br></br>
      Del dinero e' lo único que me enamoro<br></br>
      Dicen que su mujer e' fiel<br></br>Y yo por joder coroné y de una ve' lo
      volví un toro (wuh)<br></br>
      Bajamo' fijo a cien milla' en el Teodoro (¿ah?)<br></br>
      Yo soy real, por eso nada decoro (anjá)<br></br>
      Por puta' no lloro (wuh)<br></br>
      Problema' no ignoro (wuh)<br></br>
      En la mía, a nadie le hago coro (ah)<br></br>
      Ando con Ela y con Jon Z (diles)<br></br>
      Con par de culo' con flow de Beyoncé (anjá)<br></br>
      Aquí no se falla como lo hace Doncic (no)<br></br>
      Dale, ponme ese culo en la cara pa' comerte como un munchie (wuh)<br></br>
      Na' má' corro por efectivo<br></br>
      24/7 pa'l joseo activo (anjá)<br></br>
      Queremo' de lejo' to' lo negativo<br></br>
      Te hicieron la prueba de falso y diste positivo (wuh)<br></br>
      <br></br>
      Yo no corro por un culo, solo por un cheque (cheque)<br></br>
      Me lo mueve y se menea, eso parece tembleque (ah) (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (brr) (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (ey) (24/7)<br></br>
      Yo no corro por un culo, solo por un cheque (wuh)<br></br>
      Me lo mueve y se menea, eso parece tembleque (anjá) (tembleque)<br></br>
      Shorty me twerkea al ritmo 'e mi fulete (brr) (fulete)<br></br>
      Puesto pa'l joseo, to' los día' 24/7 (ey)
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </p>
  );
};

export default Lyrics;
